interface TypingIndicatorProps {
  name?: string | null;
}

const Dot = ({ delay }: { delay: string }) => (
  <span
    className="h-2 w-2 animate-bounce rounded-full bg-slate-400"
    style={{ animationDelay: delay }}
  />
);

export const TypingIndicator = ({ name }: TypingIndicatorProps) => (
  <div className="flex items-center gap-3 rounded-2xl bg-slate-100 px-4 py-2 text-sm text-slate-500 shadow-inner">
    <span className="font-medium">{name ?? "Someone"}</span>
    <span className="flex items-center gap-1">
      <Dot delay="0ms" />
      <Dot delay="120ms" />
      <Dot delay="240ms" />
    </span>
  </div>
);


